import React from "react";

interface DashedConnectorProps {
  width?: number;
  height?: number;
}

export const DashedConnector = ({
  width = 200,
  height = 60,
}: DashedConnectorProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d={`M0 ${height * 0.7}C${width * 0.25} ${height * 0.1} ${width * 0.75} ${height * 0.9} ${width} ${height * 0.3}`}
      stroke="#1c252e"
      strokeWidth="3"
      strokeDasharray="10 8"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
